<div class="container workbook">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="iframeContainer">
        <iframe
          class="responsive-iframe"
          [src]="(this.locale==='es' ? 
                  'https://docs.google.com/gview?url=https://bhavaniapp.s3.us-east-2.amazonaws.com/static/guia_dosis_terapeuticas.pdf&embedded=true':
                  'https://docs.google.com/gview?url=https://bhavaniapp.s3.us-east-2.amazonaws.com/static/Therapeutic_Dose_Guide.pdf&embedded=true')|safeUrl"
           frameborder="0" allowfullscreen=""
        ></iframe>
      </div>
    </div>
  </div>
</div>
<scroll-top-floating-component></scroll-top-floating-component>